module.exports = __webpack_public_path__ + "img/f8d126c459dd15b0e2cc2dded5cefa8.d92978c5.png";